module.exports = __webpack_public_path__ + "img/ax.2c33ce8d.svg";